import {
    AnalyticsEvent,
    EVENT_UAEVENT,
    GTMEventData,
} from "@hermes/utils/analytics";

import { EVENT_PRODUCT_GRID, FILTERS, CLEAR } from "../constants/grid.constant";

export class GridFilterClearedEvent implements AnalyticsEvent<GTMEventData> {
    public name: string = EVENT_UAEVENT;

    /**
     * Mandatory parameter of AnalyticsEvent.
     */
    public eventData = {};

    public formatForGTM(): GTMEventData {
        return {
            event: EVENT_UAEVENT,
            eventcategory: EVENT_PRODUCT_GRID,
            eventaction: FILTERS,
            eventlabel: CLEAR,
        };
    }
}
